export function upsertEntityById(items, entity, idKey = 'id') {
  if (!Array.isArray(items)) {
    return [];
  }
  const entityId = entity?.[idKey];
  if (!entityId) {
    return items;
  }
  const index = items.findIndex((item) => item?.[idKey] === entityId);
  if (index === -1) {
    return items;
  }
  const next = [...items];
  next[index] = entity;
  return next;
}

export function removeEntityById(items, entityId, idKey = 'id') {
  if (!Array.isArray(items) || !entityId) {
    return items || [];
  }
  const index = items.findIndex((item) => item?.[idKey] === entityId);
  if (index === -1) {
    return items;
  }
  const next = [...items];
  next.splice(index, 1);
  return next;
}
